import {TextoMidiaEnum} from '../../enum/texto-midia-enum';
import {SafeResourceUrl} from '@angular/platform-browser';

export class TemplateCabecalhoModel {

  id?: number;
  textoOuMidia: TextoMidiaEnum = TextoMidiaEnum.TEXTO;
  titulo?: string;
  format?: string;
  file?: any;

  //uso front
  blob?: SafeResourceUrl;

}
